/** Claves de query para TanStack Query. Misma clave = mismo cache. */
export const queryKeys = {
  vehicles: ["vehicles"] as const,
  vehicle: (id: string) => ["vehicles", id] as const,
  vehicleCategories: ["vehicleCategories"] as const,
  vehicleBrands: ["vehicleBrands"] as const,
  parts: ["parts"] as const,
  part: (id: string) => ["parts", id] as const,
  partCategories: ["partCategories"] as const,
  partBrands: ["partBrands"] as const,
  users: ["users"] as const,
  user: (id: string) => ["users", id] as const,
  financingRequestsCount: ["financingRequestsCount"] as const,
  financingRequests: ["financingRequests"] as const,
  raffles: ["raffles"] as const,
  raffle: (id: string) => ["raffles", id] as const,
  raffleEntries: (raffleId: string) => ["raffles", raffleId, "entries"] as const,
  adminSettings: ["adminSettings"] as const,
  quotes: ["quotes"] as const,
  quote: (id: string) => ["quotes", id] as const,
  payments: ["payments"] as const,
  payment: (id: string) => ["payments", id] as const,
  announcements: ["announcements"] as const,
  homeSections: ["homeSections"] as const,
  homeConfig: ["homeConfig"] as const,
  quoteRequests: ["quoteRequests"] as const,
  vehicleCount: ["vehicleCount"] as const,
  userCount: ["userCount"] as const,
  financingByStatus: ["financingByStatus"] as const,
  quotesByMonth: ["quotesByMonth"] as const,
  vehiclesByType: ["vehiclesByType"] as const,
  recentFinancings: ["recentFinancings"] as const,
  recentQuotes: ["recentQuotes"] as const,
  recentQuoteRequests: ["recentQuoteRequests"] as const,
  topVehicles: ["topVehicles"] as const,
  pendingFinancingCount: ["pendingFinancingCount"] as const,
  quoteCount: ["quoteCount"] as const,
} as const;
